const defaultTextValues = {
  sectionTitle: {
    en: `What's on`
  },
  fullAgendaLink: {
    en: `View full agenda`
  }
};

export default defaultTextValues;
